import { LEGAL_LAST_UPDATED } from '@/constants/site.constants';
import { SUPPORT_CONTENT } from '@/features/legal/constants/support.constants';
import { useDocumentTitle } from '@/hooks/useDocumentTitle.hook';
import type { LegalDocumentContent } from '@/types/legal.types';

interface UseSupportPageResult {
  content: LegalDocumentContent;
  lastUpdated: string;
}

export const useSupportPage = (): UseSupportPageResult => {
  useDocumentTitle(
    'Support | Shoutt',
    'How to get help with Shoutt: contact us, account and sign-in, rentals and deposits, reporting, and grievance redressal.',
  );

  return { content: SUPPORT_CONTENT, lastUpdated: LEGAL_LAST_UPDATED };
};
